if($('.id--16, .id--17').length){
    $('.step.step-3 span').text('Dodací údaje');
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'));
    $('.contact-box').after('<div class="customCare"><div class="top"><div class="left"><img src="'+$('.contact-box img').attr('data-src')+'"></div><div class="right"><p>Potřebujete Poradit?</p><div class="h4"><strong>'+$('.contact-box>strong').text()+'</strong> <span>Zákaznická péče</span></div></div></div><div class="bottom"><ul class="contactBoxCustom"></ul><ul class="customCartContact"></ul></div></div>')
    
    $('ul.contactBoxCustom').append($('.contact-box span.tel').closest('li').clone())
    $('ul.contactBoxCustom').append($('.contact-box span.mail').closest('li').clone())
    $('ul.customCartContact').append($('.contact-box span.facebook').closest('li').clone())
    $('ul.customCartContact').append($('.contact-box span.instagram').closest('li').clone())
    $('ul.customCartContact').append($('.contact-box span.messenger').closest('li').clone())
    $('ul.customCartContact').append($('.contact-box span.whatsapp').closest('li').clone())

}

if($('.id--9').length){

    function mhProductInfoMove(){
        $('.step.step-3 span').text('Dodací údaje');
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
        $('.discount-coupon').prepend('<div class="haveDiscrountTitle">Mám slevový / dárkový poukaz</div>')
        $('.discount-coupon form').hide();
        if(!$('.cart-content .cart-table').length){
            $('body').addClass('cart-emptied');
            if(sessionStorage.empty_cart) {
                $('.empty-cart-boxes').after('<div class="favoriteCategory">'+sessionStorage.empty_cart+'</div>')
              } else {
                $.ajax({
                  type: "GET",
                  dataType: "html",
                  timeout: 1e4,
                  cache: !0,
                  url: "/",
                  success: function(e) {
                      var a = shoptet.common.createDocumentFromString(e),
                      t = $(a).find('.favoriteCategory').closest('div').html();
                      null !== t && ($(".empty-cart-boxes").after('<div class="favoriteCategory">'+t+'</div>'))
                      sessionStorage.empty_cart = t
                      }
                  });
            }
            $('.col-md-4').prepend('<div class="emptyCartContent"><h1 style="display:block;">'+$('h1').text()+'</h1><p>'+emptyCartCopy+'</p><p><a href="/" class="btn btn-primary">Do obchodu</a></p></div>')
            
            $('.contact-box').after('<div class="customCare"><div class="top"><div class="left"><img src="'+$('.contact-box img').attr('data-src')+'"></div><div class="right"><p>Potřebujete Poradit?</p><div class="h4"><strong>'+$('.contact-box>strong').text()+'</strong> <span>Zákaznická péče</span></div></div></div><div class="bottom"><ul class="contactBoxCustom"></ul><ul class="customCartContact"></ul></div></div>')
    
            $('ul.contactBoxCustom').append($('.contact-box span.tel').closest('li').clone())
            $('ul.contactBoxCustom').append($('.contact-box span.mail').closest('li').clone())
            $('ul.customCartContact').append($('.contact-box span.facebook').closest('li').clone())
            $('ul.customCartContact').append($('.contact-box span.instagram').closest('li').clone())
            $('ul.customCartContact').append($('.contact-box span.messenger').closest('li').clone())
            $('ul.customCartContact').append($('.contact-box span.whatsapp').closest('li').clone())
        }
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
    $('html').on('click', '.haveDiscrountTitle', function(){
        $(this).toggleClass('active');
        $('.discount-coupon form').slideToggle();
    })
}

if($('.id--17').length){
    $('.cart-content>.co-contact-information>h4').text('Dodací údaje');
}